import { FETCH_ME } from "../../constants/action-constants";

const initialState = {
  data: {},
};

const meReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ME:
      return { data: action.payload };
    default:
      return state;
  }
};

export default meReducer;
